import { type ReactElement } from 'react';
import { Link } from 'react-router-dom';

export function LearnerPrimaryAction({
  applicationId,
  applicationStatus,
  academicBagId,
  documentsPolicy = 'MANDATORY',
}: {
  applicationId: string;
  applicationStatus: string;
  academicBagId: string | null;
  documentsPolicy?: 'MANDATORY' | 'OPTIONAL';
}): ReactElement | null {
  if (applicationStatus === 'REGISTERED' && academicBagId) {
    return (
      <Link className="btn btn-secondary" to={`/applications/${applicationId}/subjects`}>
        Choose subjects
      </Link>
    );
  }

  if (applicationStatus === 'REGISTRATION_PENDING_PAYMENT') {
    return (
      <Link className="btn btn-secondary" to={`/register/payment?applicationId=${applicationId}`}>
        Pay registration fee
      </Link>
    );
  }

  if (applicationStatus === 'CHANGES_REQUESTED' && academicBagId) {
    return (
      <Link className="btn btn-secondary" to={`/applications/${applicationId}/subjects`}>
        Revise subject choices
      </Link>
    );
  }

  if (applicationStatus === 'AWAITING_PARENT_DECISION') {
    return (
      <Link className="btn btn-secondary" to={`/applications/${applicationId}/partial-approval`}>
        Review partial approval
      </Link>
    );
  }

  if (
    applicationStatus === 'APPROVAL_COMPLETE'
    || applicationStatus === 'QUOTATION_ISSUED'
    || applicationStatus === 'PAYMENT_PENDING'
  ) {
    return (
      <Link className="btn" to={`/applications/${applicationId}/payment`}>
        Pay subject fees
      </Link>
    );
  }

  if (applicationStatus === 'ADMISSION_PROVISIONAL' || applicationStatus === 'ADMISSION_CONFIRMED') {
    if (documentsPolicy === 'OPTIONAL') return null;
    // Document-upload module parked.
    // return (
    //   <Link className="btn btn-secondary" to={`/applications/${applicationId}/documents`}>
    //     Upload documents
    //   </Link>
    // );
    return null;
  }

  return null;
}
